
export const padLeft = (str, totalDigits=2) => {
  const zeros = [...Array(totalDigits).keys()]
  return [
    ...zeros.slice(0, -1 * str.length ),
    ...str.split(''),
  ].join('')
}
